import {createContext} from "react";

export const AgentRequestContext = createContext({
  agentId: null,
  setAgentId: () => {
  },
  modalOpen: false,
  setModalOpen: () => {
  },
  agentRequest: {
    id: "",
    name: "",
    family: "",
    father_name: "",
    national_code: "",
    birth_date: "",
    gender: "",
    photo: "",
    degree_id: null,
    stage_degree_id: null,
    degree_file: "",
    home_phone: "",
    province_id: null,
    city_id: null,
    email: "",
    address: "",
    experience: "",
    speciality: "",
    about_me: "",
    resume_file: "",
    introduction_file: "",
    introduction: "",
    step: null,
    status: "",
    branch_ids: null,
    agent_tid: null,
  },
  setAgentRequest: () => {

  },
  agentLogs: [],
  setAgentLogs: () => {
  },
  agentLog: {
    id: null,
    agent_id: null,
    admin_id: null,
    comment: "",
    status: "",
    create_date: "",
  },
  setAgentLog: () => {

  },
  agentDisplayDetail: {
    agent_id: null,
    rate: null,
    views: null,
    installment: false,
    visit_card: "",
    clip: "",
    education_clip_1: "",
    education_clip_2: ""
  },
  setAgentDisplayDetail: () => {
  },
  agentRequestBranches: {
    id: null,
    agent_id: null,
    field_id: null,
    field_title: "",
    branch_id: null,
    branch_title: "",
    status: "",
  },
  setAgentRequestBranches: () => {
  },
  agentBranches: {
    id: null,
    agent_id: null,
    field_id: null,
    field_title: "",
    branch_id: null,
    branch_title: "",
    status: "",
  },
  setAgentBranches: () => {
  },
  confirmationComments: [],
  setConfirmationComments: () => {
  },
  activeStep: null,
  setActiveStep: () => {

  },
  isLastStep: false,
  setIsLastStep: () => {

  },
  isFirstStep: false,
  setIsFirstStep: () => {

  },
  allowedStep: null,
  setAllowedStep: () => {

  },
  handleNext: () => {

  },
  handlePrev: () => {
    
  },

})